<template>
<v-container fluid>
  <v-card>
  <v-card-title>
     <span class="font-weight-bold grey--text grey--darken-2">布局信息</span>
  </v-card-title>
  <v-divider></v-divider>

  <v-card-text>
  <v-row>
  <v-col cols="12" md="3">
  <v-text-field label="资源容量" v-model.number="capacity" disabled></v-text-field>
  </v-col>
  <v-col cols="12" md="2">
  <v-text-field label="行数" v-model.lazy.number="row"></v-text-field>
  </v-col>
  <v-col cols="12" md="2">
  <v-text-field label="列数" v-model.lazy.number="col"></v-text-field>
  </v-col>
  <v-col cols="12" md="3">
  <v-text-field label="总数" v-model.number="total" disabled></v-text-field>
  </v-col>
  <v-col cols="12" md="2">
  <v-btn color="green" class="mt-3" outlined @click="generate()">产生</v-btn>
  </v-col>
  </v-row>
  </v-card-text>
  </v-card>
  <v-card>
  <v-col cols="12" v-show="total>0" >
          <v-row
            align="center"
            justify="center"
            class="ml-2"
          >
            <v-card style="height:25px;width:25px"
              v-for="c in numCol"
              :key="c"
              class="ml-2 ma-2"
              tile
            >{{c}}
            </v-card>
          </v-row>
          <v-row
            align="center"
            justify="center"
            v-for=" r in numRow"
            :key="r"
            :class="getColor(r)"
          >
            <span style="width:25px"> {{r}} </span>
            <v-card style="height:25px;width:25px"
              v-for="c in numCol"
              :key="c"
              class="ma-2"
              outlined
              tile
              @click="mark(r+'-'+c)"
              :class="getAvailability(r,c)?'grey lighten-3':'black'"
            >
            <v-icon v-show="(c+r)%2===0">mdi-human-male</v-icon>
            </v-card>
          </v-row>
    </v-col>
   </v-card>
</v-container>
</template>

<script>
export default {
    name:'layoutConfig',
    data:()=>(
        {
            numRow : 10,
            numCol:  10,
            row: 10,
            col: 10,
            capacity: 100,
            total: 0,
            availability: [,]
        }
    ),
    methods:{
        generate(){
            if (this.row && this.col)
            {
                this.numRow = this.row;
                this.numCol = this.col;
                this.total = this.numRow * this.numCol;
                this.availability = [,];

                this.availability = new Array();
                for (let i=0;i<50;i++)
                {        
                    this.availability[i] = new Array();
            
                    for (let j=0;j<this.numCol;j++)
                        this.availability[i][j] = 0;
                }
            }
        },
        getColor(r)
        {
            return (r%2)===0 ? 'grey lighten-5' : 'white';
        },
        getAvailability(r,c)
        {
            if (this.availability.length===1){
                this.availability = new Array();

                for (let i=0;i<50;i++)
                {
                        this.availability[i] = new Array();

                        for (let j=0;j<50;j++)
                            this.availability[i][j] = 0;
                }
                return true;
            }
            console.log(r+" "+c);
            if (this.availability[r][c]===1)
               return false;
            else
                return true;
        },
        mark(idx)
        {
            var r = parseInt(idx.split('-')[0]);
            var c = parseInt(idx.split('-')[1]);
            console.log('You clicked Row '+r+' , Col '+c);

            if (this.availability[r][c]===1) this.availability[r][c]=0;
            else this.availability[r][c]=1;

            console.log(this.availability[r][c]);
            this.total = 0;
             this.$nextTick(() => {
                this.total=this.numRow * this.numCol;
            });
        }
    },
    mounted()
    {
        this.availability = new Array();

         for (let i=0;i<50;i++)
        {
            this.availability[i] = new Array();

            for (let j=0;j<50;j++)
                this.availability[i][j] = 0;
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/management/LayoutConfiguration.vue